import { routers } from "config/routes";
import useStore from "config/store";

interface CompanyData {
  id: ID;
  name: string;
  internalReference: string;
  accountingFirm?: { id: ID; name: string };
}

export function useGetAndSaveCompanies() {
  const setIsCompanySelectOpen = useStore(state => state.setIsCompanySelectOpen);
  const setCompanySelected = useStore(state => state.setCompanySelected);
  const setAccountingFirmSelected = useStore(state => state.setAccountingFirmSelected);

  const onSaveCompany = (companyData: unknown) => {
    const company = companyData as CompanyData;

    setCompanySelected({
      id: company.id,
      name: company.name,
      internalReference: company.internalReference,
    });

    if (company.accountingFirm) {
      setAccountingFirmSelected({
        id: company.accountingFirm.id,
        name: company.accountingFirm.name,
      });
    }

    routers.navigate(`/company/${company.id}`);

    setIsCompanySelectOpen(false);
  };

  return { onSaveCompany };
}
